import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { IAlertFallDetection } from '@/api/notification/getNotificationFallDetection.ts'

export const apiGetFallDetectionDetail = async (id?: number) => {
    return await apiGet<IAlertFallDetection>(`/alert/falldetection/${id}`)
}

const useQueryGetFallDetectionDetail = (id?: number, enabled: boolean = true) => {
    return useQuery({
        queryKey: QueryCacheKeys.notification.getFallDetectionDetail(id),
        enabled: ((id || -1) >= 0) && enabled,
        refetchInterval: 1000,
        queryFn: async () => {
            const { data } = await apiGetFallDetectionDetail(id)
            return data
        }
    })
}

export default useQueryGetFallDetectionDetail 
